<div
    class="sr-app-light:text-black gl-light:bg-blue-alert vl-app-light:bg-[#085667] vl-app-light:rounded-lg orb-app-light:text-black flex items-center space-x-2 rounded bg-primary px-4 py-3 text-sm font-medium text-white dark:bg-contrast-black dark:text-contrast-yellow"
    [ngClass]="{
        'orb-app-light:bg-grey-light bg-primary': type === 'info',
        'vl-app-light:text-secondary bg-transparent': type === 'light-info',
        'vl-app-light:bg-[#F0F0F0] vl-app-light:text-secondary': type === 'grey-info'
    }"
    role="alert">
    <ion-icon
        class="alert-icon"
        *ngIf="showIcon && env.APP_NAME === 'vastmanland-app'"
        [ngClass]="{
            'h-8 w-8': type !== 'grey-info',
            'h-6 w-6': type === 'grey-info'
        }"
        src="{{
            (assetsPath$ | async) +
                (type === 'info' ? '/img/explore/info_icon.svg' : '/img/purchase-flow-v2/result/info-icon.svg')
        }}"></ion-icon>
    <mat-icon *ngIf="showIcon && env.APP_NAME === 'sormland'">info_outline</mat-icon>
    <ridango-ui-icons
        class="alert-info-icon var-app-light:!text-white orb-app-light:text-blue-alert_icon orb-app-light:![--product-info-icon-fg:white] h-6x2 w-6x2"
        *ngIf="showIcon && env.APP_NAME !== 'sormland' && env.APP_NAME !== 'vastmanland-app'"
        [name]="'productInfo'"
        aria-hidden="true">
    </ridango-ui-icons>
    <div class="max-w-xs text-base"><ng-content></ng-content></div>
</div>
